<template>
  <div id="app">
    <!-- Loader starts-->
    <div class="loader-wrapper" :class="{'loderhide' : !show }">
      <div class="loader loader-7">
        <div class="line line1"></div>
        <div class="line line2"></div>
        <div class="line line3"></div>
      </div>
    </div>
    <!-- Loader ends-->

    <!--<Main/>-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      show: true
    };
  },
  mounted() {
    this.timeOut();
  },
  methods: {
    timeOut() {
      // this.basketAddSuccess = true;
      var self = this;
      setTimeout(function() {
        self.show = false;
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.loader-wrapper.loderhide {
  display: none;
}
</style>
<style>
.link_txt{
    color: blue;
    cursor: pointer;
}
tr{
  box-shadow: 0px 0px 1px 3px rgba(239, 238, 238, 0);
}
@media (max-width: 767.98px){
  tr{
  box-shadow: 0px 0px 1px 3px rgb(93, 92, 92);
}
}
</style>

<style>
th{
    text-align: unset !important;
}
.table th, .table td {
    padding: 0.25rem !important;
}
.google_btn{
  cursor: pointer;
  border:1px solid rgb(88, 88, 245);
  border-radius: 5px;
}
.google_btn:hover{
  border:2px solid rgb(0, 0, 255);
}
.cust_txt {
    max-width: 8em;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    position: relative;
}
.cust_txt:hover::after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 0;
    background-color: #333;
    color: white;
    padding: 5px 10px;
    border-radius: 5px;
    white-space: nowrap;
    z-index: 1000;
    font-size: 18px;
    pointer-events: none;
    margin-bottom: 5px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

/* Apply ellipsis and proper width to all multiselect option text with cust_txt class */
.multiselect__option .cust_txt,
.multiselect__single .cust_txt,
.multiselect__single span.cust_txt {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
    position: relative;
}

/* Apply ellipsis to selected values in multiselect */
.multiselect__single {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    padding-right: 40px; /* Space for dropdown arrow */
}

/* Ensure proper width constraints for multiselect container */
.multiselect__tags {
    overflow: hidden;
}

/* Apply to any .cust_txt inside multiselect tags (selected values) */
.multiselect__tags .cust_txt {
    display: inline-block;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
}
.res_text {
  display: inline-block;
  max-width: 20em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  cursor: pointer;
}
.res_text:hover {
  max-width: auto;
  text-overflow: clip;
  white-space: normal;
}
.copy_cursor:hover{
  cursor: copy;
}
.card .card-header {
  padding: 20px !important;
}
.cursor_pointer{
  cursor: pointer;
}

.breadcrumbHeader > .breadcrumb {
  background-color: inherit !important;
  margin-bottom: 0;
  padding: 0rem 0rem;
  margin: 0rem 0rem !important;
}

.breadcrumb-item + .breadcrumb-item::before {
  padding-right: 1px !important;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 1px !important;
}

/* Ensure proper layout structure */
.page-wrapper {
  min-height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
}

.page-body-wrapper {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important; /* Allow proper flex behavior */
}

.page-body {
  background-color: #F2F7FF !important;
  flex: 1 1 auto !important;
  overflow-x: hidden !important;
  padding-bottom: 20px !important;
  min-height: calc(100vh - 200px) !important; /* Minimum height to prevent collapse */
}

/* .page-wrapper .page-main-header {
  height: 8% !important;
  align-items: start !important;
}
.page-wrapper .page-body-wrapper .page-body {
  margin-top: 7% !important;
} */

.page-main-header .main-header-right .mobile-sidebar {
  padding-right: 0px !important;
}

.page-main-header .main-header-right .nav-right.right-menu ul li .user-header .media-body span + span {
  font-size: 14px !important;
  font-weight: normal !important;
}

.page-main-header .main-header-right .nav-right.right-menu ul {
  justify-content: flex-end !important;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {
  /* margin-top: 1rem !important; */
  padding: 0rem 0rem !important;
}

.sidebar{
  padding-top: 10px;
}
.sidebar-header {
  padding: 0.8rem 0.5rem !important;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a {
  font-size: 0.9vw !important;
  font-weight: 400 !important;
  transition: 0.05s !important;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 32px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a::after {
  content: '';
  display: block;
  width: 25px;
  height: 25px;
  background-image: url('data:image/svg+xml;utf8,<svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 6L12 10L8 14" stroke="%237C8DB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.7;
  transition: opacity 0.2s;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li:last-child > a,
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.logout-link {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding-right: 32px;
  padding-left: 20px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li:last-child > a::after,
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.logout-link::after {
  display: none;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.logout-link .middle {
  color: #f84109 !important;
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%) scaleX(-1);
  font-size: 1.2em;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.logout-link span {
  color: inherit !important;
  margin-right: 0;
  margin-left: 0;
  padding-left: 0.5em;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li:last-child {
  margin-top: auto;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.active {
  font-size: 1vw !important;
  font-weight: 500 !important;
  color: #DDE2FF !important;
  background: linear-gradient(to right, rgba(159,162,180,0.08) 70%, rgba(159,162,180,0.00) 100%) !important;
  border-left: 3px solid rgba(221, 226, 255, 1) !important;
  /* Faded effect for active tab */
  filter: brightness(1.15) grayscale(0.15) opacity(0.85);
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.active::after {
  opacity: 0.5;
}

.showBreadcrumbs {
  display: none !important;
}

.page-main-header .main-header-right {
  padding: 0.5rem 1rem 0.5rem 1rem !important;
  margin: 0rem 0rem !important;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
  border-radius: 0% !important;
  background-color: #ffffff !important;
}

.custom-card-shadow {
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px !important;
}

.custom-font-16 {
  font-size: 0.85vw !important;
}

.custom-font-18 {
  font-size: 1vw !important;
}

.custom-font-20 {
  font-size: 1.1vw !important;
}

.custom-font-22 {
  font-size: 1.2vw !important;
}

.custom-font-24 {
  font-size: 1.25vw !important;
}

.custom-font-26 {
  font-size: 1.354vw !important;
}

.custom-font-30 {
  font-size: 1.4vw !important;
}

.custom-font-32 {
  font-size: 1.6vw !important;
}

.custom-font-34 {
  font-size: 2.05vw !important;
}

.custom-font-36 {
  font-size: 2.145vw !important; 
}

.custome-title{
  font-weight: 600 !important; 
  font-size: 2.145vw !important; 
}

.add-monitor-btn-green {
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px !important;
  background: #2FB234 !important;
  color: #fff !important;
  border: 1.5px solid #2FB234 !important;
  border-radius: 12px !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  padding: 0 24px !important;
  height: 48px !important;
  cursor: pointer !important;
  transition: background 0.2s, color 0.2s !important;
  box-shadow: none !important;
}

.add-monitor-btn-green:hover {
  background: #28A22C !important;
  border-color: #28A22C !important;
}

.add-monitor-btn-icon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #2FB234 !important;
  color: #fff !important;
  border: 1.5px solid #2FB234 !important;
  border-radius: 12px !important;
  height: 48px !important;
  cursor: pointer !important;
  transition: background 0.2s, color 0.2s !important;
  box-shadow: none !important;
  padding: 0 20px !important;
}

.add-monitor-btn-icon:hover {
  background: #28A22C !important;
  border-color: #28A22C !important;
}

/* Ensure green variant takes precedence */
.add-monitor-btn-green.add-monitor-btn-icon {
  background: #2FB234 !important;
  border-color: #2FB234 !important;
}

.add-monitor-btn-green.add-monitor-btn-icon:hover {
  background: #28A22C !important;
  border-color: #28A22C !important;
}

.add-monitor-btn-dark {
  display: inline-flex !important;
  align-items: center !important;
  gap: 10px !important;
  background: #101828 !important;
  color: #fff !important;
  border: 1.5px solid #101828 !important;
  border-radius: 12px !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 18px !important;
  font-weight: 500 !important;
  padding: 0 24px !important;
  height: 48px !important;
  cursor: pointer !important;
  transition: background 0.2s, color 0.2s, border-color 0.2s !important;
  box-shadow: none !important;
}

.add-monitor-btn-dark:hover {
  background: #1D2939 !important;
  border-color: #1D2939 !important;
}

.add-monitor-btn-dark.add-monitor-btn-icon {
  width: 48px !important;
  height: 48px !important;
  padding: 0 !important;
  justify-content: center !important;
  background: #101828 !important;
  border-color: #101828 !important;
}

.add-monitor-btn-dark.add-monitor-btn-icon:hover {
  background: #1D2939 !important;
  border-color: #1D2939 !important;
}

.custom-btn-dark {
  font-size: 1.1vw;
  padding: 0.332rem 2.1vw !important;
  background-color: #2FB234 !important;
  cursor: pointer !important;
  border-radius: 10px !important;
}

.custom-btn-dark:hover {
  background-color: #00b300 !important;
  color: white !important;
}

.custom-btn {
  font-size: 1.1vw !important;
  padding: 0.16rem 2vw !important;
  border-radius: 8px !important;
}

.showMonitorBtn {
 display: none !important;
}

.form-group {
  margin-bottom: 0rem !important;
}

.multiselect {
  font-size: 1vw !important;
}

.multiselect .multiselect__input, 
.multiselect .multiselect__option,
.multiselect .multiselect__placeholder,
.multiselect .multiselect__tags-wrap,
.multiselect .multiselect__tags,
.multiselect .multiselect__content {
  font-size: 1vw !important;
  border-radius: 8px !important;
}


.multiselect .multiselect__option--highlight {
  font-size: 1.2vw;
}

.multiselect__single {
  font-size: 1.2vw !important;
  padding: 0.7vh 0vw !important;
}

.multiselect__select {
  margin: 0.26vw !important;
}

.custom-select {
  padding: 0.375rem 1.4rem 0.375rem 0.75rem !important;
}

.search-bg{
  background-color: inherit !important;
  border-right: 0px;
  height: auto;
}

.gray-font{
  color: rgb(98, 98, 98);
}

.media-body label {
  margin-bottom: 0rem !important;
  margin-top: 0.2rem !important;
}

.switch-outline .switch-state:before {
  background-color: #E70000 !important;
}

.switch-outline .switch input:checked + .switch-state.bg-success:before {
  background-color: #188107 !important;
}

.datatable-vue table {
  border: inherit !important;
}

.datatable-vue .table thead th {
  border-bottom: 0.8px solid #2F2F2F !important;
}


.datatable-vue .table th, .table td {
  border-top: inherit !important;
  border-bottom: 0.6px solid #00000099 !important;
}

.datatable-vue table tbody tr:nth-child(odd),
.datatable-vue table tbody tr:nth-child(odd) td:first-child,
.datatable-vue table tbody tr:nth-child(even) td:first-child,
.datatable-vue table tbody tr:nth-child(even):hover td   {
  background-color: inherit !important;
}

.datatable-vue .incidents-table tbody tr td,
.datatable-vue .events-table tbody tr td{
  padding: 0.5rem 0rem !important;
}

/* Alert contact table */
.alert-table .table thead th:nth-child(5){
  width: 18% !important;
}

.card {
  box-shadow: none !important;
  -wekit-box-shadow: none !important;
}

.card .card-header h5:not(.mb-0) {
  font-family: 'Work Sans', sans-serif !important;
}

.card .card-header h5 {
  font-size: 1.2rem !important;
}

.cus-search-input .input-group-text {
  background-color: #ffffff !important;
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
  border: 0.6px solid rgba(58, 58, 58, 1);
  padding-right: 0rem !important;
}

.cus-search-input .form-control {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  border: 0.6px solid rgba(58, 58, 58, 1);
}

.col-form-label {
  width: 7vw !important;
  margin-bottom: 0% !important;
  padding-top: calc(0.4rem + 1px) !important;
}

.pagination {
  justify-content: end;
}

.pagination {
  display: inline-block;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color .3s;
  border: 1px solid #ddd;
  font-size: 12px;
}

.pagination a.active {
  background-color: #007bff;
  color: white;
  border: 1px solid #007bff;
}

.pagination a:hover:not(.active) {background-color: #ddd; cursor: pointer;}


.badge-gray {
  background-color: rgb(120, 120, 120) !important;
  color: #ffffff !important;
}

/* Invalid (Red Border + Icon) */
.invalid-select .multiselect__tags {
  border: 1px solid #dc3545 !important; /* Red border */
  border-radius: 4px;
  position: relative;
}

.invalid-select .multiselect__tags::after {
  content: "❗";
  color: #dc3545; /* Red color */
  font-size: 18px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

/* Valid (Green Border + Icon) */
.valid-select .multiselect__tags {
  border: 1px solid #28a745 !important; /* Green border */
  border-radius: 4px;
  position: relative;
}

.valid-select .multiselect__tags::after {
  content: "✔";
  color: #28a745; /* Green color */
  font-size: 30px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}


/* Invalid (Red Border + Icon) */
.invalid-timepicker input {
  border: 1px solid #dc3545 !important; /* Red border */
  border-radius: 4px;
  position: relative;
  padding-right: 30px; /* Space for the icon */
}

.invalid-timepicker::after {
  content: "❗";
  color: #dc3545; /* Red color */
  font-size: 14px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

/* Valid (Green Border + Icon) */
.valid-timepicker input {
  border: 1px solid #28a745 !important; /* Green border */
  border-radius: 4px;
  position: relative;
  padding-right: 30px; /* Space for the icon */
}

.valid-timepicker::after {
  content: "✔";
  color: #28a745; /* Green color */
  font-size: 22px;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

/* Custom tabs */
.nav-tabs .nav-item a{
  font-size: 20px !important;
}

@media (max-width: 768px) {
  /* .page-wrapper .page-main-header {
    height: 5% !important;
    align-items: start !important;
  }

  .page-wrapper .page-body-wrapper .page-body {
    margin-top: 15% !important;
  } */

  .multiselect__single,
  .custom-font-16,
  .custom-font-18,
  .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a {
    font-size: 0.8rem !important;
  }

  .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu > li > a.active {
    font-size: 0.9rem !important;
  }
  
  .page-wrapper .page-main-header .main-header-left .logo-wrapper {
    margin-left: 90px !important;
  }

  .res_text {
    max-width: 12em;
  }

  .custom-font-20 {
    font-size: 0.9rem !important;
  }

  .custom-font-22 {
    font-size: 1rem !important;
  }

  .custom-font-24,
  .custom-font-26 {
    font-size: 1.15rem !important;
  }

  .custom-font-30,
  .custom-font-34,
  .custome-title {
    font-size: 1.2rem !important;
  }

  .custom-font-36 {
    font-size: 1.7rem !important; 
  }

  .add-monitor-btn-green,
  .add-monitor-btn-dark {
    font-size: 14px !important;
    padding: 0 16px !important;
    height: 44px !important;
    border-radius: 10px !important;
  }

  .custom-btn-dark {
    font-size: 0.8rem !important;
    padding: 0.2rem 0.29rem  !important;
    border-radius: 5px !important;
  }

  .custom-btn {
    font-size: 0.8rem !important;
    padding: 0.2rem 7.1vw !important;
    border-radius: 5px !important;
  }

  /* .cust-monitor-btn-cont > .col-md-6 {
    width: auto !important; 
  } */

  .multiselect,
  .multiselect .multiselect__input, 
  .multiselect .multiselect__option,
  .multiselect .multiselect__placeholder,
  .multiselect .multiselect__tags-wrap,
  .multiselect .multiselect__tags,
  .multiselect .multiselect__content,
  .multiselect__single  {
    font-size: 16px !important;
  }

  .multiselect__content-wrapper {
    width: auto !important;
  }


  .multiselect .multiselect__option--highlight {
    font-size: 16px;
  }

  .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
    text-align: left !important;
    width: 40% !important;
  }

  .datatable-vue .table tbody {
    border: 1px solid black !important;
    border-radius: 10px !important;
  }

  .datatable-vue .table tbody tr {
    box-shadow: inherit !important;
    -webkit-box-shadow: inherit !important;
    padding: 0.5rem 0.5rem !important;
    border-bottom: 1px solid black !important;
  }

  .datatable-vue .table tbody tr > td {
    border: 0px !important;
  }

  .datatable-vue .table tbody tr:last-child {
    border-bottom: 0px !important;
  }

  .datatable-vue .table th, .table td {
    border-top: inherit !important;
    border-bottom: inherit !important;
  }

  .datatable-vue .incidents-table tbody tr td{
    padding: 0.25rem !important;
  }

  .table-responsive {
    overflow-x: visible !important;
  }

  .page-wrapper .page-body-wrapper .page-header .breadcrumb {
    margin-top: 0px !important;
  }

  .page-wrapper .page-body-wrapper .page-header .breadcrumb .breadcrumb-item a,
  .page-wrapper .page-body-wrapper .page-header .breadcrumb li {
    font-family: 'Work Sans', sans-serif !important;
  } 

  .switch {
    width: 46px !important;
    height: 24px !important; 
  }

  .switch-state:before {
    width: 15px !important;
    height: 15px !important;
    left: 1px !important;
  }

  .media-body label {
    margin-bottom: 0rem !important;
    margin-top: 0rem !important;
  }

  .col-form-label {
    width: 100px !important;
  }
}

@media (max-width: 1200px) {
  .showBreadcrumbs {
    display: block !important;
  }

  .breadcrumbHeader {
    display: none !important;
  }

  .showMonitorBtn {
    display: block !important;
  }
  .hideMonitorBtn {
    display: none !important;
  }
  
  .add-monitor-btn-icon,
  .add-monitor-btn-dark.add-monitor-btn-icon {
    width: 48px !important;
    height: 48px !important;
    border-radius: 12px !important;
  }
}

/* Global Modal Styles */
.modal-content {
  border-radius: 20px !important;
  border: 1px solid #D2E3FB !important;
  overflow: hidden;
}

/* Ensure modal header and footer also respect the border radius */
.modal-header {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  border-bottom: 1px solid #D2E3FB !important;
}

/* Remove border for modal header when no-border class is applied */
.custom-modal .modal-header:has(.no-border) {
  border-bottom: none !important;
}

.modal-footer {
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  border-top: 1px solid #D2E3FB !important;
}

/* Fix for Bootstrap modal backdrop */
.modal-dialog {
  margin-top: 5rem;
}

/* Global Modal Header and Title Styles */
.custom-modal .modal-header {
  border-bottom: none !important;
  padding: 30px 30px 0 30px !important;
}

/* Hide default Bootstrap modal title */
.custom-modal .modal-header .modal-title {
  display: none !important;
}

.custom-modal-header {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 12px !important;
  width: 100% !important;
  position: relative !important;
}

.custom-modal-title {
  font-family: 'Poppins', sans-serif !important;
  font-weight: 600 !important;
  font-size: 26px !important;
  color: #3A3A3A !important;
  margin: 0 !important;
  text-align: center !important;
}

.custom-modal-close {
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  background: none !important;
  border: none !important;
  font-size: 38px !important;
  font-weight: 300 !important;
  line-height: 1 !important;
  color: #6B7280 !important;
  cursor: pointer !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 4px !important;
  transition: all 0.2s ease !important;
}

.custom-modal-close:hover {
  background: #F3F4F6 !important;
  color: #374151 !important;
}

.custom-modal .modal-body {
  padding: 30px !important;
  font-family: 'Poppins', sans-serif !important;
}
</style>
